import type { ErrorCode } from "./codes";

/** The standard response envelope (API-STANDARD.md §1). Shared with the client. */
export interface ErrorDetail {
  field?: string;
  issue: string;
}

export interface ApiError {
  code: ErrorCode;
  message: string;
  details?: ErrorDetail[];
  retryable: boolean;
}

export interface ApiMeta {
  page?: number;
  pageSize?: number;
  total?: number;
  nextCursor?: string | null;
}

export interface ApiEnvelope<T> {
  isSuccess: boolean;
  data: T | null;
  error: ApiError | null;
  correlationId: string;
  meta?: ApiMeta;
}

export function isApiEnvelope(value: unknown): value is ApiEnvelope<unknown> {
  return (
    typeof value === "object" &&
    value !== null &&
    "isSuccess" in value &&
    "correlationId" in value &&
    "data" in value &&
    "error" in value
  );
}
